module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded),
      expression: "pageLoaded"
    }]
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": _vm.member.info.headimgurl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "个人信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "用户ID",
      "value": _vm.member.info.id
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "昵称",
      "value": _vm.member.info.nick_name
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "会员等级",
      "value": _vm.userLevel
    }
  }), _vm._v(" "), (_vm.member.info.mobile > 0) ? _c('cell', {
    attrs: {
      "title": "联系电话",
      "value": _vm.member.info.mobile
    }
  }) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "他的推荐人",
      "value": _vm.member.info.ref_nick_name
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "关注日期",
      "value": _vm.member.info.create_time
    }
  })], 1), _vm._v(" "), _c('group', [_c('x-button', {
    attrs: {
      "link": "BACK"
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccf1648"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/ReferInfo.vue
// module id = 652
// module chunks = 0